import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './languages/en';
import bg from './languages/bg';
import de from './languages/de';
import ptBr from './languages/ptBr';
import fr from './languages/fr';

const resources = {
  en: {
    translation: en,
  },
  bg: {
    translation: bg,
  },
  de: {
    translation: de,
  },
  ptBr: {
    translation: ptBr,
  },
  fr: {
    translation: fr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
